<template>
    <div class="col-12 mt-2">
        <form id="payment-form" @submit.prevent="handleSubmit">
            <div id="payment-element">
                <!-- Stripe.js injects the Payment Element -->
            </div>

            <div class="w-100 text-start ts-2 mt-5 d-flex justify-content-end">
                <button class="generalButton t-xl-12 t-xxl-8 t-30 t-sm-24" @click="pay()" v-if="ready">Pagar</button>
            </div>

            <div id="payment-message" v-if="paymentMessage" :class="{ 'text-danger': isError, 'text-success': !isError }">
                {{ paymentMessage }}
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: "stripe",
    emits:['setData', 'progress', 'showModal', 'setLoading', 'result'],
    props: {
        formFields: {},
        con: {},
    },
    data() {
        return {
            ready:false,
            stripe: null,
            elements: null,
            clientSecret: '', // Esto lo obtendrás del backend
            loading: false,
            paymentMessage: '',
            isError: false,
        };
    },
    mounted() {
        // Obtén el clientSecret desde tu backend
        if(this.formFields.step1.amount.value!=0){
            this.setPayIntent(this.formFields.step1.amount.value);
        }else{
            this.$parent.$emit('showModal', {type:'error', message:'Monto en 0', title:'Porfavor definir un costo'});
        }
    },
    methods: {
        async setPayIntent(amount=1000){
            this.con.setPaymentIntent({
                token: this.con.defToken,
                data: {
                    'amount': amount,
                    'currency': 'mxn'
                }
            }).then((data) => {

                this.clientSecret = data.data.clientSecret;
                
                // Inicializar Stripe
                this.stripe = Stripe('pk_test_51QQFqy07N6To3xP4KxZH3pLQXbN8q6M3IB0rtKM8ihyi4ef4XJsHVLfMw4ghvxlpTNbSIfnOWokUKKOUsicznl3A00HZah4JdB'); // Reemplaza con tu clave pública
                const appearance = {
                    theme: 'flat', // Tema oscuro
                    variables: {
                        fontFamily: '"fatfrank", sans-serif',
                    }
                };

                this.elements = this.stripe.elements({ clientSecret: this.clientSecret, appearance, locale: 'es' });

                // Montar el Payment Element
                const paymentElement = this.elements.create('payment');
                paymentElement.on('ready', () => {
                    this.ready = true; // El formulario está completamente renderizado
                });
                paymentElement.mount('#payment-element');
            }).catch((error) => {
                console.error(error);
            }); 
        },
        async pay() {
            this.$parent.$emit('setLoading', true);

            try {
                // Confirmar el pago
                const { error, paymentIntent } = await this.stripe.confirmPayment({
                    elements: this.elements,
                    redirect: 'if_required'
                });

                if (error) {
                    // Emitir el error al componente padre
                    this.$emit('result', { success: false, message: error.message });
                } else if (paymentIntent.status === 'succeeded') {
                    // Emitir el resultado exitoso al componente padre
                    this.$emit('result', { success: true, data:paymentIntent });
                }
            } catch (err) {
                console.error('Error al procesar el pago:', err);
                this.$emit('result', { success: false, message: 'Error inesperado al procesar el pago' });
            }
        },
    },
};
</script>
